import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LightbulbDimIcon} from 'shells/icon/svg/lightbulb-dim-icon';
import {PopupNotification} from 'shells/popup-notification/popup-notification';

import styles from './data-notice-popover.module.css';

type Props = {
    onClickReview: () => any;
    onClickDismiss: () => any;
    entityName: React.ReactNode;
};

export function DataNoticePopover(props: Props) {
    return (
        <div className={styles['data-notice-popover-container']}>
            <PopupNotification
                icon={LightbulbDimIcon}
                iconColor={colors.plumDk}
                title='Review new data'
                body={
                    <div className={styles['notice-content']}>
                        Nutshell Intelligence has found additional information about{' '}
                        {props.entityName}
                    </div>
                }
                onClose={props.onClickDismiss}
                actionButton={{
                    text: 'Review',
                    onClick: props.onClickReview,
                    isNotificationClickTarget: true,
                }}
            />
        </div>
    );
}
